<template>
  <div>
    <h4> {{$t('leads.details.hearing_test_web')}}</h4>
    <template>
      <div v-if="ht">
        <div>
          <span class="is-bold">{{$t('leads.details.ht_web.test_type')}}:</span> {{ $t(`leads.details.ht_web.${ht.test_type}`) }}
        </div>
        <div>
          <span class="is-bold">{{$t('leads.details.ht_web.version')}}:</span> {{ ht.test_version }}
        </div>
        <div v-if="ht.headphones_type && ht.headphones_type==='mono'">
          <span class="is-bold">{{$t('leads.details.mono_result')}}:</span>
          <span v-if="ht.hl_left"> {{$t('leads.details.ht_web.with_hearing_loss')}} ({{$t('leads.details.ht_web.difference_sound_noise')}}: {{ ht.sound_left - ht.noise_left }} dB)</span>
          <span v-else> {{$t('leads.details.ht_web.without_hearing_loss')}} ({{$t('leads.details.ht_web.difference_sound_noise')}}: {{ ht.sound_left - ht.noise_left }} dB)</span>
        </div>
        <span v-else>
          <div>
            <span class="is-bold">{{$t('leads.details.left')}}:</span>
            <span v-if="ht.hl_left"> {{$t('leads.details.ht_web.with_hearing_loss')}} ({{$t('leads.details.ht_web.difference_sound_noise')}}: {{ ht.sound_left - ht.noise_left }} dB)</span>
            <span v-else> {{$t('leads.details.ht_web.without_hearing_loss')}} ({{$t('leads.details.ht_web.difference_sound_noise')}}: {{ ht.sound_left - ht.noise_left }} dB)</span>
          </div>
          <div>
            <span class="is-bold">{{$t('leads.details.right')}}:</span>
            <span v-if="ht.hl_right"> {{$t('leads.details.ht_web.with_hearing_loss')}} ({{$t('leads.details.ht_web.difference_sound_noise')}}: {{ ht.sound_right - ht.noise_right }} dB)</span>
            <span v-else> {{$t('leads.details.ht_web.without_hearing_loss')}} ({{$t('leads.details.ht_web.difference_sound_noise')}}: {{ ht.sound_right - ht.noise_right }} dB)</span>
          </div>
        </span>
      </div>
      <div v-else>
        {{$t('leads.details.no_result')}}
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: ['ht'],
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
    activeHearingTest: function () {
      if (this.ht) {
        return this.ht.id
      }
    }
  },
  watch: {
    activeHearingTest: {
      immediate: true,
      handler (value) {
        if (this.ht) {
          // this.updateResults(this.ht.result)
        }
      }
    }
  }
}
</script>
